import { assignInlineVars } from "@vanilla-extract/dynamic";
import clsx from "clsx";
import React from "react";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { ArticleCardSerializer } from "web/types/serializers";
import * as styles from "./secondary-article-card.css";

interface SecondaryArticleCardProps
    extends Pick<
        ArticleCardSerializer,
        "title" | "thumbnails" | "is_sponsored" | "article_url" | "position"
    > {
    onClick: (area: string) => void;
}

export function SecondaryArticleCard({
    title,
    thumbnails,
    is_sponsored: isSponsored,
    article_url: articleUrl,
    position,
    onClick,
}: SecondaryArticleCardProps): React.ReactElement {
    return (
        <div data-testid={`editorial-content-card-secondary-${position}`}>
            <a href={articleUrl}>
                <View className={styles.secondaryArticleContent}>
                    <View
                        marginRight={{ sm: "sm", md: "none" }}
                        marginBottom={{ sm: "none", md: "xxs" }}
                        className={clsx(
                            styles.secondaryArticleContentBlock,
                            styles.secondaryArticleImageContainer
                        )}
                    >
                        <View
                            className={styles.flexContainer}
                            onClick={() => onClick("image")}
                            dataTestId="secondary-article-image"
                        >
                            <img
                                className={clsx({
                                    [styles.thumbnailMask]: isSponsored,
                                })}
                                src={thumbnails?.landscape.sm}
                            />
                            {isSponsored && (
                                <>
                                    <View
                                        style={assignInlineVars({
                                            [styles.overlayBackgroundHeight]: "48%",
                                        })}
                                        className={styles.thumbnailTextOverlayBackground}
                                    />
                                    <View
                                        padding={{ sm: "xxs", md: "sm" }}
                                        className={styles.thumbnailTextOverlayContainer}
                                    >
                                        <Text textStyle="caption-3" color="information" upperCase>
                                            {gettext("general.sponsored_label")}
                                        </Text>
                                    </View>
                                </>
                            )}
                        </View>
                    </View>
                    <View
                        marginTop="xxs"
                        marginRight={{
                            sm: "xxs",
                            md: "none",
                        }}
                        paddingRight={{
                            sm: "none",
                            md: "lg",
                        }}
                        className={clsx(
                            styles.secondaryArticleContentBlock,
                            styles.secondaryArticleTextContainer
                        )}
                        onClick={() => onClick("cta")}
                        dataTestId="secondary-article-cta"
                    >
                        <View>
                            <View marginBottom="xs">
                                <Text textStyle="caption-1" color="primary" wordBreak lineLimit={2}>
                                    {title}
                                </Text>
                            </View>
                            <Text textStyle="body-s-bold" color="primary" underline>
                                {gettext("general.read_and_shop")}
                            </Text>
                        </View>
                    </View>
                </View>
            </a>
        </div>
    );
}
